import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { ToggleButton } from '@piplapps/pipl-ui';
import styles from './EnforceAuth.module.less';
import EnforceAuthModal from './EnforceAuthModal';

const SsoSettings = (props) => {
  const [modal, toggleModal] = useState(false);
  const _handleSwitchChange = useCallback(() => {
    if (props.status) {
      toggleModal(!modal);
    } else {
      toggleModal(!modal);
    }
  }, [props.status]);

  function getModalStyle() {
    return {
      width: '528px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      border: 'none',
      borderRadius: '8px',
      padding: '40px 80px',
      backgroundColor: '#ffffff',
    };
  }

  return (
    <div>
      <strong className={styles.title}>{props.auth}</strong>
      {props.isAbleToEnforceLogin ? (
        <strong className={styles.connected}>✓ {gettext('Connected')}</strong>
      ) : (
        <div className={styles.unableToEnforce}>
          {gettext(`You must be connected with your ${props.auth} account to enable.`)}
        </div>
      )}
      <div className={styles.container}>
        <Popup open={modal} modal onClose={toggleModal} contentStyle={getModalStyle()} closeOnDocumentClick={false}>
          <EnforceAuthModal
            auth={props.auth}
            toggleModal={toggleModal}
            disableLogin={props.disableLogin}
            enableLogin={props.enableLogin}
            status={props.status}
          />
        </Popup>
        <ToggleButton
          checkStatus={props.status}
          offText={gettext('no')}
          onText={gettext('yes')}
          switchChangeHandle={_handleSwitchChange}
          disabled={!props.isAbleToEnforceLogin}
        />
        <div className={styles.text}>{gettext('Force login with ') + props.auth}</div>
        {props.loginUpdateStatus ? <div>{gettext('Unknown Error')}</div> : null}
      </div>
    </div>
  );
};

SsoSettings.propTypes = {
  auth: PropTypes.string,
  status: PropTypes.bool,
  disableLogin: PropTypes.func,
  enableLogin: PropTypes.func,
  loginUpdateStatus: PropTypes.bool,
  isAbleToEnforceLogin: PropTypes.bool,
};

export default SsoSettings;
